import jsCookie from "js-cookie";
import { useState, useEffect, useRef } from "react";
import SentIcon from "../../../components/icons/common/send";
import classNames from "classnames";
import { LoaderIcon } from "react-hot-toast";
import { CrossIcon } from "../../../components/icons";
import { useAppSelector } from "src/hooks/redux";
import IconFile from "../../../components/icons/side-bar/icon-file";
import { useNavigate } from "react-router-dom";

interface Props {
  sendQuery: (query: string, answer: string, file?: File[], button?: boolean) => void;
  setanswer: (query: string) => void;
  query: string;
  answer: string;
  uploadStatus?: boolean;
  setFile: (file: File[]) => void;
  fileRequired?: boolean;
  allDisabled?: boolean;
}

const AddQueryAgent = ({
  query,
  answer,
  uploadStatus,
  fileRequired,
  setFile,
  sendQuery,
  setanswer,
  allDisabled,
}: Props) => {
  const navigate = useNavigate();
  const textareaRef = useRef<any>(null);
  const fileInputRef = useRef<any>(null);
  const [attachedFiles, setAttachedFiles] = useState<File[]>([]);
  const [error, setError] = useState<string | null>(null);

  const handleAttachClick = () => {
    fileInputRef.current?.click();
  };

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const files = event.target.files;
    if (files && files.length > 0) {
      const validTypes = [
        "application/pdf",
        "application/vnd.ms-powerpoint",
        "application/vnd.openxmlformats-officedocument.presentationml.presentation",
        "application/msword",
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        // Excel formats
        "application/vnd.ms-excel",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        // CSV
        "text/csv",
        // JSON
        "application/json"
      ];

      const selectedFiles: File[] = Array.from(files).filter((file) =>
        validTypes.includes(file.type),
      );

      if (selectedFiles.length !== files.length) {
        setError("Some files have invalid types. Only PDF, PPT, Excel or Word documents are allowed.");
      } else {
        setError(null);
      }

      setAttachedFiles((prevFiles) => [...prevFiles, ...selectedFiles]);

      // Optional: If your `setFile` must still send 1 file (the first one)
      if (selectedFiles.length > 0) {
        setFile(selectedFiles);
      }

      event.target.value = "";
    }
  };

  const handleRemoveFile = (index: number) => {
    setAttachedFiles((prevFiles) => prevFiles.filter((_, i) => i !== index));
  };

  useEffect(() => {
    if (textareaRef.current) {
      textareaRef.current.style.height = "auto";
      textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`;
    }
    textareaRef.current.focus();
  }, [query, answer]);

  const handleKeyDown = (event: React.KeyboardEvent) => {
    if (event.key === "Enter" && !event.shiftKey && answer.trim() !== "") {
      sendQuery(query, answer, attachedFiles || undefined);
      setAttachedFiles([]);
      event.preventDefault();
    }
  };

  const handleDrop = (e: any) => {
    e.preventDefault();
    if (!uploadStatus && fileRequired) return;

    const droppedFiles: File[] = e.dataTransfer.files;
    if (droppedFiles && droppedFiles.length > 0) {
      const validTypes = [
        "application/pdf",
        "application/vnd.ms-powerpoint",
        "application/vnd.openxmlformats-officedocument.presentationml.presentation",
        "application/msword",
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        // Excel formats
        "application/vnd.ms-excel",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        // CSV
        "text/csv",
        // JSON
        "application/json"
      ];

      const selectedFiles: File[] = Array.from(droppedFiles).filter((file) =>
        validTypes.includes(file.type),
      );

      if (selectedFiles.length !== droppedFiles.length) {
        setError(
          "Some dropped files are invalid type. Only PDF, PPT, Excel or Word documents are allowed.",
        );
      } else {
        setError(null);
      }

      setAttachedFiles((prevFiles) => [...prevFiles, ...selectedFiles]);

      if (selectedFiles.length > 0) {
        setFile(selectedFiles);
      }
    }
  };

  const handleDragOver = (e: any) => {
    if (!uploadStatus && fileRequired) return;
    e.preventDefault();
  };

  const accessToken = jsCookie.get("pn_refresh");

  return (
    <div className="flex flex-col w-full mb-[20px]">
      {/* {!accessToken ? (
        <div className="mb-2 w-full flex flex-col rounded-lg border border-gray-200 shadow-inputBox overflow-hidden bg-white relative mb-[20px]">
          <div className="flex justify-between p-2 border-b bg-white items-center">
            <p className="text-sm font-600 text-black font-nunito">
              Save your progress, revisit past chats, and upload your own data, and more
            </p>
            <div className="flex justify-end gap-2">
              <button
                className={classNames(
                  "disabled:cursor-not-allowed flex items-center justify-center gap-2 px-4 py-1 font-600 hover:shado hover:scale-[1.03] duration-500 rounded-full bg-primary-900 border border-primary-900 text-white border-primary-900",
                )}
                onClick={() => navigate("/signup")}
              >
                Sign up
              </button>
              <button
                className={classNames(
                  "disabled:cursor-not-allowed flex items-center justify-center gap-2 px-4 py-1 font-600 hover:shado hover:scale-[1.03] duration-500 rounded-full  text-secondary-400 border border-secondary-400 hover:bg-secondary-400 hover:text-white  border-primary-900",
                )}
                onClick={() => navigate("/login")}
              >
                Login
              </button>
            </div>
          </div>
        </div>
      ) : null} */}

      <div
        onDrop={handleDrop}
        onDragOver={handleDragOver}
        className="w-full flex flex-col rounded-lg border border-gray-200 shadow-inputBox overflow-hidden bg-white relative mb-[0px]"
      >
        <div className="flex items-center p-1">
          <textarea
            ref={textareaRef}
            onChange={(e) => setanswer(e.target.value)}
            disabled={(fileRequired && uploadStatus) || allDisabled}
            value={answer}
            onKeyDown={handleKeyDown}
            className={classNames(
              "appearance-none leading-tight w-full h-full p-2 border-none rounded-md bg-white placeholder:text-appGray-600 focus:border-none focus-visible:border-none focus:outline-none focus:ring-0",
              uploadStatus || allDisabled ? "cursor-not-allowed" : "",
            )}
            placeholder="Type here"
          />
        </div>

        <div className="bg-appGray-100 rounded-b-lg p-2 flex items-center flex-wrap gap-2">
          {!allDisabled && (uploadStatus || !fileRequired) ? (
            <>
              <button className="inline-flex items-center" onClick={handleAttachClick}>
                <IconFile /> <span className="ml-1">Attach</span>
              </button>

              <input
                type="file"
                multiple
                ref={fileInputRef}
                onChange={handleFileChange}
                className="file-input hidden"
              />

              {attachedFiles.map((file, index) => (
                <div
                  key={index}
                  className="flex items-center bg-white border p-1 rounded shadow-sm"
                >
                  <span className="text-sm mr-2">{file.name}</span>
                  <button onClick={() => handleRemoveFile(index)}>
                    <CrossIcon className="h-3 w-3 text-red-500" />
                  </button>
                </div>
              ))}

              {error && <div className="flex items-center text-red-500 text-sm">{error}</div>}
            </>
          ) : (
            <div className="py-1"></div>
          )}

          <div className="absolute right-2">
            <button
              disabled={allDisabled}
              className={`bg-primary-900 text-white rounded-full h-4 w-4 flex items-center justify-center cursor-pointer ${allDisabled || (!attachedFiles.length && !answer.trim())
                ? "!cursor-not-allowed"
                : ""
                }`}
              type="button"
              onClick={() => {
                if (!attachedFiles.length && !answer.trim()) return;
                sendQuery(query, answer, attachedFiles || undefined);
                setAttachedFiles([]);
              }}
            >
              <SentIcon className="h-2 w-2" />
            </button>
          </div>
        </div>
      </div>

      <div className="pt-2 text-center text-sm text-black font-nunito">
        Review your inputs carefully before proceeding; previous steps cannot be revisited.
      </div>
    </div>
  );
};

export default AddQueryAgent;
